import {useEffect} from "react";
import {connect} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {getNotFoundPageInternalUrl} from "../constants/appRoutes";
import {setAppLanguage} from "../state/app/appActions";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  languages: state.app.languages,
  node: state.node
});

const mapDispatchToProps = dispatch => ({
  setAppLanguage: (language, nodeId) => dispatch(setAppLanguage(language, nodeId))
});

const MultiLanguageDomain = ({appLanguage, languages, node, setAppLanguage, children}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {lang: language} = useParams();

  useEffect(() => {
    if (language !== appLanguage) {
      if (language && languages.includes(language)) {
        setAppLanguage(language, node ? node.nodeId : null);
      } else {
        navigate(getNotFoundPageInternalUrl());
      }
    }
  }, [language, appLanguage, languages, setAppLanguage, node, navigate, location.pathname]);

  return appLanguage === language && languages.includes(language) ? children : null;
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiLanguageDomain);
